import React from "react";
import { Box, Typography } from "@mui/material";
import PopUp from "./../PopUp"
import construct from "../../assets/img/new/construction.png"

function FeatureBanner() {
    return (
        <>
            <Box
                className="banner"
                sx={{
                    background: `url(${construct})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    width: "100%",
                    paddingBottom: { xs: "150px", md: "50px" },
                    // height: "470px",
                    height: { xs: "auto", md: "110vh" },
                    display: "flex",
                    flexWrap: "wrap",
                    // margin: { xs: "10px", md: "30px" },
                }}
            >
                <Box
                    sx={{
                        flex: 1,
                        padding: { xs: "20px", md: "50px" },
                        marginTop: { xs: "100px", lg: "100px" },
                        marginLeft: { xs: "0px", md: "70px" },
                    }}
                >
                    <Typography
                        variant="h3"
                        fontWeight="bold"
                        textAlign="initial"
                        sx={{
                            fontSize: {
                                lg: 42,
                                md: 32,
                                sm: 32,
                                xs: "28px",
                            },
                            color: "white",
                            // marginTop: { md: "50px", xs: "0px" },
                            width: { xs: "100%", md: "80%", lg: "60% !important" }
                        }}
                    >
                        Fast & Visual All-in-One Project Management ERP Software for Architects
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: "white",
                            fontSize: { md: "22px", xs: "18px", sm: "22px" },
                            marginTop: { md: "25px", xs: "10px" },
                            width: { xs: "100%", md: "80%", lg: "50% !important" }
                        }}
                    >
                        StackArch is a comprehensive architectural project management ERP software that offers web and mobile platforms specifically designed for architects. It is an all-in-one solution that streamlines and automates various aspects of architectural project management, providing architects with a powerful tool to enhance productivity and efficiency.
                    </Typography>
                    <PopUp margin={"50px"} background={"#e6f7ff"} color={"#4F46E5"} />
                </Box>
            </Box>

        </>
    );
}

export default FeatureBanner;
